// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusAiBlock__KAv5m {
  display: inline-flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 5px;
}
@media (max-width: 800px) {
  .statusAiBlock__KAv5m {
    flex-direction: column;
  }
}

.statusWrapper__hsf2M {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.statusAi__izdes {
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: lowercase;
  white-space: nowrap;
  padding: 2px 10px;
  border-radius: 10px;
}

.commentsCount__Q8u_u {
  position: relative;
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding: 0px 10px 0px 14px;
}
.commentsCount__Q8u_u::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5px;
}

.standard__Fu1Jj {
  color: var(--labels-filled-text);
  border: 1px solid var(--labels-filled-surface-standard);
}
.standard__Fu1Jj .statusAi__izdes {
  background: var(--labels-filled-surface-standard);
}
.standard__Fu1Jj .commentsCount__Q8u_u {
  color: var(--labels-filled-surface-standard);
}
.standard__Fu1Jj .commentsCount__Q8u_u::before {
  background: var(--labels-filled-surface-standard);
}

.high__bx8E4 {
  color: var(--labels-filled-text);
  border: 1px solid var(--labels-filled-surface-high);
}
.high__bx8E4 .statusAi__izdes {
  background: var(--labels-filled-surface-high);
}
.high__bx8E4 .commentsCount__Q8u_u {
  color: var(--labels-filled-surface-high);
}
.high__bx8E4 .commentsCount__Q8u_u::before {
  background: var(--labels-filled-surface-high);
}

.critical__blGoZ {
  color: var(--labels-filled-text-reversed-white);
  border: 1px solid var(--labels-filled-surface-critical);
}
.critical__blGoZ .statusAi__izdes {
  background: var(--labels-filled-surface-critical);
}
.critical__blGoZ .commentsCount__Q8u_u {
  color: var(--labels-filled-surface-critical);
}
.critical__blGoZ .commentsCount__Q8u_u::before {
  background: var(--labels-filled-surface-critical);
}

.archived__Hfj_c {
  color: var(--labels-filled-text-reversed-white);
  border: 1px solid var(--labels-filled-stroke-archived);
}
.archived__Hfj_c .statusAi__izdes {
  background: var(--labels-filled-surface-archived);
}
.archived__Hfj_c .commentsCount__Q8u_u {
  color: var(--labels-filled-surface-archived);
}
.archived__Hfj_c .commentsCount__Q8u_u::before {
  background: var(--labels-filled-surface-archived);
}

.troubleshooting___hNtg {
  color: var(--labels-outline-stroke-text-archived);
  border: 1px solid var(--labels-outline-stroke-text-archived);
}
.troubleshooting___hNtg .rightBorder__x4HhP {
  border-right: 1px solid var(--labels-outline-stroke-text-archived);
}
.troubleshooting___hNtg .commentsCount__Q8u_u {
  color: var(--labels-outline-stroke-text-archived);
}
.troubleshooting___hNtg .commentsCount__Q8u_u::before {
  background: var(--labels-outline-stroke-text-archived);
}
@media (min-width: 1536px) {
  .troubleshooting___hNtg .rightBorder__x4HhP {
    border-right: unset;
  }
  .troubleshooting___hNtg .commentsCount__Q8u_u {
    display: none;
  }
}

.declined__GiL_G {
  color: var(--labels-outline-stroke-text-archived);
  border: 1px solid var(--labels-outline-stroke-text-archived);
}
@media (max-width: 800px) {
  .declined__GiL_G {
    order: 2;
  }
}

@media (max-width: 1536px) {
  .hideSnoozeDateTime__dDefm {
    display: none;
  }
}

.statusTooltip__BsPII {
  max-width: 400px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/StatusTypeItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,QAAA;AAzEF;AA2EE;EAPF;IAQI,sBAAA;EAxEF;AACF;;AA2EA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAxEF;AA0EE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;AAxEJ;;AA4EA;EACE,gCAAA;EACA,uDAAA;AAzEF;AA2EE;EACE,iDAAA;AAzEJ;AA4EE;EACE,4CAAA;AA1EJ;AA4EI;EACE,iDAAA;AA1EN;;AA+EA;EACE,gCAAA;EACA,mDAAA;AA5EF;AA8EE;EACE,6CAAA;AA5EJ;AA+EE;EACE,wCAAA;AA7EJ;AA+EI;EACE,6CAAA;AA7EN;;AAkFA;EACE,+CAAA;EACA,uDAAA;AA/EF;AAiFE;EACE,iDAAA;AA/EJ;AAkFE;EACE,4CAAA;AAhFJ;AAkFI;EACE,iDAAA;AAhFN;;AAqFA;EACE,+CAAA;EACA,sDAAA;AAlFF;AAoFE;EACE,iDAAA;AAlFJ;AAqFE;EACE,4CAAA;AAnFJ;AAqFI;EACE,iDAAA;AAnFN;;AAwFA;EACE,iDAAA;EACA,4DAAA;AArFF;AAuFE;EACE,kEAAA;AArFJ;AAwFE;EACE,iDAAA;AAtFJ;AAwFI;EACE,sDAAA;AAtFN;AA0FE;EACE;IACE,mBAAA;EAxFJ;EA2FE;IACE,aAAA;EAzFJ;AACF;;AA6FA;EACE,iDAAA;EACA,4DAAA;AA1FF;AA4FE;EAJF;IAKI,QAAA;EAzFF;AACF;;AA6FE;EADF;IAEI,aAAA;EAzFF;AACF;;AA4FA;EACE,gBAAA;EAnLA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AA2FF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.statusAiBlock {\n  display: inline-flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 5px;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n  }\n}\n\n.statusWrapper {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.statusAi {\n  font-family: 'Roboto', sans-serif;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: lowercase;\n  white-space: nowrap;\n  padding: 2px 10px;\n  border-radius: 10px;\n}\n\n.commentsCount {\n  position: relative;\n  font-family: 'Roboto', sans-serif;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  padding: 0px 10px 0px 14px;\n\n  &::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 100%;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 5px;\n  }\n}\n\n.standard {\n  color: var(--labels-filled-text);\n  border: 1px solid var(--labels-filled-surface-standard);\n\n  .statusAi {\n    background: var(--labels-filled-surface-standard);\n  }\n\n  .commentsCount {\n    color: var(--labels-filled-surface-standard);\n\n    &::before {\n      background: var(--labels-filled-surface-standard);\n    }\n  }\n}\n\n.high {\n  color: var(--labels-filled-text);\n  border: 1px solid var(--labels-filled-surface-high);\n\n  .statusAi {\n    background: var(--labels-filled-surface-high);\n  }\n\n  .commentsCount {\n    color: var(--labels-filled-surface-high);\n\n    &::before {\n      background: var(--labels-filled-surface-high);\n    }\n  }\n}\n\n.critical {\n  color: var(--labels-filled-text-reversed-white);\n  border: 1px solid var(--labels-filled-surface-critical);\n\n  .statusAi {\n    background: var(--labels-filled-surface-critical);\n  }\n\n  .commentsCount {\n    color: var(--labels-filled-surface-critical);\n\n    &::before {\n      background: var(--labels-filled-surface-critical);\n    }\n  }\n}\n\n.archived {\n  color: var(--labels-filled-text-reversed-white);\n  border: 1px solid var(--labels-filled-stroke-archived);\n\n  .statusAi {\n    background: var(--labels-filled-surface-archived);\n  }\n\n  .commentsCount {\n    color: var(--labels-filled-surface-archived);\n\n    &::before {\n      background: var(--labels-filled-surface-archived);\n    }\n  }\n}\n\n.troubleshooting {\n  color: var(--labels-outline-stroke-text-archived);\n  border: 1px solid var(--labels-outline-stroke-text-archived);\n\n  .rightBorder {\n    border-right: 1px solid var(--labels-outline-stroke-text-archived);\n  }\n\n  .commentsCount {\n    color: var(--labels-outline-stroke-text-archived);\n\n    &::before {\n      background: var(--labels-outline-stroke-text-archived);\n    }\n  }\n\n  @media (min-width: 1536px) {\n    .rightBorder {\n      border-right: unset;\n    }\n\n    .commentsCount {\n      display: none;\n    }\n  }\n}\n\n.declined {\n  color: var(--labels-outline-stroke-text-archived);\n  border: 1px solid var(--labels-outline-stroke-text-archived);\n\n  @media (max-width: 800px) {\n    order: 2;\n  }\n}\n\n.hideSnoozeDateTime {\n  @media (max-width: 1536px) {\n    display: none;\n  }\n}\n\n.statusTooltip {\n  max-width: 400px;\n  @include tooltip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusAiBlock": `statusAiBlock__KAv5m`,
	"statusWrapper": `statusWrapper__hsf2M`,
	"statusAi": `statusAi__izdes`,
	"commentsCount": `commentsCount__Q8u_u`,
	"standard": `standard__Fu1Jj`,
	"high": `high__bx8E4`,
	"critical": `critical__blGoZ`,
	"archived": `archived__Hfj_c`,
	"troubleshooting": `troubleshooting___hNtg`,
	"rightBorder": `rightBorder__x4HhP`,
	"declined": `declined__GiL_G`,
	"hideSnoozeDateTime": `hideSnoozeDateTime__dDefm`,
	"statusTooltip": `statusTooltip__BsPII`
};
module.exports = ___CSS_LOADER_EXPORT___;
